import { Component, input } from '@angular/core'

@Component({
    selector: 'sf-advert-cta',
    templateUrl: './advert-cta.component.html',
    styleUrl: './advert-cta.component.scss',
    host: {
        class: 'advert bg-body-secondary p-4 rounded-3 my-5',
    },
})
export class AdvertCtaComponent {
    adLogo = input<string | null>(null)
    adTitle = input<string | null>(null)
    adContent = input<string | null>(null)
}
